import axios from 'axios';
import FACET_CODES from '../constants/facetCodes';
import ActionTypes from '../constants/actionTypes';

function updateManufacturers(response) {
  return {
    type: ActionTypes.UPDATE[FACET_CODES.MANUFACTURER],
    payload: response.data
  };
}

function requestManufacturers() {
  return {
    type: ActionTypes.REQUEST[FACET_CODES.MANUFACTURER]
  };
}

function broadcastError(err) {
  return {
    type: ActionTypes.FAILED2FETCH[FACET_CODES.MANUFACTURER],
    payload: err
  };
}

export default locale => {
  return dispatch => {
    dispatch(requestManufacturers());

    return axios
      .get(
        `${
          process.env.REACT_APP_BACKEND_BASE_URL
        }/api/manufacturer?locale=${locale}`
      )
      .then(response => {
        dispatch(updateManufacturers(response));
      })
      .catch(error => {
        console.log(error);
        dispatch(broadcastError(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/fetch_manufacturers.js